// Généré par scripts/generate-version.js — ne pas modifier à la main.
export const APP_VERSION = '1.3.2';
